<mat-card>
    <mat-card-title [innerText]="cardTitle | translate"></mat-card-title>
    <mat-card-content [formGroup]="formGroupAufgabe" style="max-height: 66vh; overflow-y: auto; overflow-x: hidden">
		<span class="row">
			<mat-form-field>
				<mat-label>
					{{ "MAIN_APP_PENDENZEN_AUFGABE.status" | translate }}
				</mat-label>
				<mat-select (selectionChange)="selectedAdress($event)" formControlName="fldStatus" required>
					<mat-option *ngFor="let status of dbStatus" [value]="status.status">
						{{ status.name }}
					</mat-option>
				</mat-select>
			</mat-form-field>

			<mat-form-field>
				<mat-label>{{ "MAIN_APP_PENDENZEN_AUFGABE.wichtigkeit" | translate }}
				</mat-label>
				<mat-select formControlName="fldWichtigkeit" required>
					<mat-option *ngFor="let elem of dbImportance" [value]="elem.id">
						{{ elem.name }}
					</mat-option>
				</mat-select>
			</mat-form-field>

			<mat-form-field>
				<mat-label>{{ "MAIN_APP_PENDENZEN_AUFGABE.kategorien" | translate }}
				</mat-label>
				<mat-select formControlName="fldKategorie" multiple>
					<mat-option *ngFor="let kate of dbKategorien" [value]="kate.id">
						{{ kate.description }}
					</mat-option>
				</mat-select>
			</mat-form-field>
		</span>
        <span class="row">
			<mat-checkbox class="cbInaktiv-margin, checkbox" formControlName="fldPrivat" style="flex: 1;">
				{{ "MAIN_APP_PENDENZEN_AUFGABE.privat" | translate }}
			</mat-checkbox>
			<mat-checkbox formControlName="fldAkzeptiert" style="flex: 1;">{{ "MAIN_APP_PENDENZEN_AUFGABE.akzeptiert" | translate }}</mat-checkbox>
		</span>
        <span class="row">
			<mat-form-field>
				<mat-label>{{ "MAIN_APP_PENDENZEN_AUFGABE.objekt" | translate }}</mat-label>
				<input [matAutocomplete]="auto" aria-label="Suche" formControlName="fldObjekt" matInput placeholder="Objekt wählen" required type="text"/>
				<mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectedSearchItem($event)" [displayWith]="getObjektDesc" autoActiveFirstOption>
					<mat-option *ngFor="let objekt of filteredDescriptions | async" [value]="objekt">
						{{ objekt.beschreibung }}
					</mat-option>
				</mat-autocomplete>
			</mat-form-field>

			<span class="row">
				<mat-form-field>
					<mat-label>{{ "MAIN_APP_PENDENZEN_AUFGABE.adresse" | translate }}</mat-label>
					<mat-select (selectionChange)="selectedAdress($event)" formControlName="fldAdresse" placeholder="Adresse wählen">
						<mat-option *ngFor="let adress of objectAddresses" [value]="adress">
							{{ adress.zusammenfassung }}
						</mat-option>
					</mat-select>
				</mat-form-field>

				<mat-icon (click)="addObjectAddress()" style="width: 28px">import_contacts</mat-icon>
			</span>

		</span>
        <span class="row">
			<mat-form-field>
				<mat-label>{{ "MAIN_APP_PENDENZEN_AUFGABE.titel" | translate }}</mat-label>
				<input formControlName="fldTitel" matInput/>
			</mat-form-field>
		</span>
        <span class="row">
			<mat-form-field>
				<mat-label>{{ "MAIN_APP_PENDENZEN_AUFGABE.beschreibung" | translate }}</mat-label>
				<textarea formControlName="fldBeschreibung" matInput></textarea>
			</mat-form-field>
		</span>
        <span class="row">
			<mat-form-field>
				<mat-label>{{ "MAIN_APP_PENDENZEN_AUFGABE.beginntAm" | translate }}</mat-label>
				<input [matDatepicker]="pickerStart" formControlName="fldStartDatum" matInput/>
				<mat-datepicker-toggle [for]="pickerStart" matSuffix></mat-datepicker-toggle>
				<mat-datepicker #pickerStart></mat-datepicker>
			</mat-form-field>

			<mat-form-field>
				<mat-label>{{ "MAIN_APP_PENDENZEN_AUFGABE.fälligAm" | translate }}</mat-label>
				<input [matDatepicker]="pickerFaellig" formControlName="fldFaelligDatum" matInput/>
				<mat-datepicker-toggle [for]="pickerFaellig" matSuffix></mat-datepicker-toggle>
				<mat-datepicker #pickerFaellig></mat-datepicker>
			</mat-form-field>

			<mat-form-field>
				<mat-label>{{ "MAIN_APP_PENDENZEN_AUFGABE.zuständig" | translate }}
				</mat-label>
				<mat-select formControlName="fldMitarbeiter" multiple>
					<mat-option *ngFor="let mitarbeiter of dbMitarbeiter" [value]="mitarbeiter.userID">
						{{ mitarbeiter.lastname }} {{ mitarbeiter.firstname }}
					</mat-option>
				</mat-select>
			</mat-form-field>
		</span>
        <span class="row">
            <mat-checkbox formControlName="fldReminder" labelPosition="before">{{ "MAIN_APP_PENDENZEN_AUFGABE.erinnerung" | translate }}</mat-checkbox>
			<mat-form-field>
				<mat-label>{{ "MAIN_APP_PENDENZEN_AUFGABE.erinnerung" | translate }}</mat-label>
				<input [matDatepicker]="pickerErinnerung" formControlName="fldErinnerungDatum" matInput/>
				<mat-datepicker-toggle [for]="pickerErinnerung" matSuffix></mat-datepicker-toggle>
				<mat-datepicker #pickerErinnerung></mat-datepicker>
			</mat-form-field>

			<mat-form-field>
				<mat-label>{{ "MAIN_APP_PENDENZEN_AUFGABE.zeit" | translate }}</mat-label>
				<input formControlName="fldErinnerungZeit" matInput type="time"/>
			</mat-form-field>
		</span>
        <span class="row">
			<mat-form-field style="flex: 1;">
				<mat-label>{{ "MAIN_APP_PENDENZEN_AUFGABE.vorgabezeit" | translate }}</mat-label>
				<input formControlName="fldVorgabezeit" matInput/>
			</mat-form-field>

			<mat-checkbox (change)="changeDone($event)" formControlName="fldErledigt" style="flex: 1;" value="1">
				{{ "MAIN_APP_PENDENZEN_AUFGABE.erledigt" | translate }}
			</mat-checkbox>

			<div style="flex: 1;">
				<mat-label class="lblText">
					{{ percentValue }} % {{ "MAIN_APP_PENDENZEN_AUFGABE.erledigt" | translate }}
				</mat-label>
				<mat-slider #ngSlider [max]="100" [min]="0" [step]="1" aria-labelledby="example-name-label"><input #ngSliderThumb="matSliderThumb"
                                                                                                                   (change)="updatePercentValue({source: ngSliderThumb, parent: ngSlider, value: ngSliderThumb.value})"
                                                                                                                   [value]="percentValue"
                                                                                                                   matSliderThumb/></mat-slider>
			</div>
		</span>
    </mat-card-content>
    <mat-dialog-actions>
        <button (click)="save()" [disabled]="!formGroupAufgabe.valid" [innerText]="'MAIN_APP_DIALOG.INPUT_DIALOG.save' | translate" class="confirm" mat-stroked-button></button>
        <button [innerText]="'MAIN_APP_DIALOG.INPUT_DIALOG.cancel' | translate" class="cancel" mat-dialog-close mat-stroked-button></button>
    </mat-dialog-actions>
</mat-card>
